import * as React from "react"
import { CertificateType } from "../../../models/flags/CertificateType"
import {
    gdprTextForTax,
    gdprTextDefault,
    gdprTextForVub,
    gdprTextForCub,
    gdprTextForSta,
    gdprTextForAdr,
} from "./pages"
import Button, { Icon } from "../../../components/Buttons/ButtonComponent"

interface IPrivacyPolicyComponentProps {
    privacyPolicyTextType: PrivacyPolicyCertificateProcessTextType
    certificateType: CertificateType
}

export enum PrivacyPolicyCertificateProcessTextType {
    Default = 0,
    Issuing = 1,
    Renewal = 2,
    RenewalWithEducationLicense = 3,
    ChangeAndReplacement = 4
}

export default class PrivacyPolicyComponent extends React.Component<IPrivacyPolicyComponentProps> {
    private getText(privacyPolicyTextType: PrivacyPolicyCertificateProcessTextType, certificateType: CertificateType): JSX.Element {
        if (certificateType === CertificateType.Tax) {
            switch (privacyPolicyTextType) {
                case PrivacyPolicyCertificateProcessTextType.Issuing:
                case PrivacyPolicyCertificateProcessTextType.Renewal:
                case PrivacyPolicyCertificateProcessTextType.ChangeAndReplacement:
                case PrivacyPolicyCertificateProcessTextType.RenewalWithEducationLicense:
                    return gdprTextForTax()
                default:
                    return gdprTextDefault()
            }
        }
        else if (certificateType === CertificateType.Vub) {
            switch (privacyPolicyTextType) {
                case PrivacyPolicyCertificateProcessTextType.ChangeAndReplacement:
                    return gdprTextForVub()
                default:
                    return gdprTextDefault()
            }
        }
        else if (certificateType === CertificateType.Cub) {
            switch (privacyPolicyTextType) {
                case PrivacyPolicyCertificateProcessTextType.ChangeAndReplacement:
                    return gdprTextForCub()
                default:
                    return gdprTextDefault()
            }
        }
        else if (certificateType === CertificateType.Sta) {
            switch (privacyPolicyTextType) {
                case PrivacyPolicyCertificateProcessTextType.ChangeAndReplacement:
                    return gdprTextForSta()
                default:
                    return gdprTextDefault()
            }
        }
        else if (certificateType === CertificateType.Adr) {
            switch (privacyPolicyTextType) {
                case PrivacyPolicyCertificateProcessTextType.ChangeAndReplacement:
                    return gdprTextForAdr()
                default:
                    return gdprTextDefault()
            }
        }
        else {
            return gdprTextDefault()
        }
    }

    public render(): JSX.Element {
        const {
            privacyPolicyTextType,
            certificateType
        } = this.props

        return (
            <div>
                <Button
                    style={{ marginRight: "20px", marginTop: "5px" }}
                    className="btn btn-blue pull-right"
                    onClick={() => window.print()}
                    uiTestAttribute="print-btn">
                    <Icon name="print" />Print
                </Button>
                <div className="well-green no-border well">
                    <p></p>
                    {this.getText(privacyPolicyTextType, certificateType)}
                </div>
            </div>
        )
    }
}
